import { InventoryTypeFieldValueMessage } from "./InventoryTypeFieldValueMessage"

export class CreateInventoryItemMessage {
  isCoreProduct: boolean
  price: number
  sku: string
  totalQuantityOnHand: number
  inventoryTypeId: number
  inventoryTypeFieldValues: InventoryTypeFieldValueMessage[]

  constructor(
    isCoreProduct: boolean,
    price: number,
    sku: string,
    totalQuantityOnHand: number,
    inventoryTypeId: number,
    inventoryTypeFieldValues: InventoryTypeFieldValueMessage[]) {
      this.isCoreProduct = isCoreProduct
      this.price = price
      this.sku = sku
      this.totalQuantityOnHand = totalQuantityOnHand
      this.inventoryTypeId = inventoryTypeId
      this.inventoryTypeFieldValues = inventoryTypeFieldValues
  }
}
